<script lang="ts">
    import { cn } from "../../../utils.js";
    import { DropdownMenu as DropdownMenuPrimitive } from "bits-ui";

    let {
        ref = $bindable(null),
        sideOffset = 4,
        portalProps,
        class: className,
        ...restProps
    }: DropdownMenuPrimitive.ContentProps & {
        portalProps?: DropdownMenuPrimitive.PortalProps;
    } = $props();
</script>

<DropdownMenuPrimitive.Portal {...portalProps}>
    <DropdownMenuPrimitive.Content
        bind:ref
        data-slot="dropdown-menu-content"
        {sideOffset}
        class={cn(
            "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--bits-dropdown-menu-content-available-height) min-w-[8rem] origin-(--bits-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md outline-none",
            className,
        )}
        {...restProps}
    />
</DropdownMenuPrimitive.Portal>
